import router from "@/router";
import { functions } from "@/services/firebase";

/**
 * Authenticate user via Firebase Function (secure)
 * This keeps the client_secret secure on the server side
 *
 * @param {string} username - User's username
 * @param {string} password - User's password
 * @returns {Promise<Object|null>} Authentication response with access_token
 */
export async function authenticate(username, password) {
  try {
    // Call Firebase Function instead of SSO directly
    // This keeps client_secret secure on the server
    const authenticateWithSSO = functions.httpsCallable(
      "auth-authenticateWithSSO"
    );
    const result = await authenticateWithSSO({ username, password });

    return result.data;
  } catch (error) {
    console.error("Authentication error:", error);

    // Return null for consistency with previous implementation
    return null;
  }
}

export async function autoSignIn(intendedDestinationParam) {
  const intendedDestination =
    intendedDestinationParam ||
    (router.currentRoute && router.currentRoute.fullPath) ||
    "/";

  if (!process.env.VUE_APP_CSA_USERNAME || !process.env.VUE_APP_CSA_PASSWORD) {
    router.replace({
      name: "login",
      query: { redirect: intendedDestination },
    });
    return false;
  }

  const response = await authenticate(
    process.env.VUE_APP_CSA_USERNAME,
    process.env.VUE_APP_CSA_PASSWORD
  );

  if (response && response.access_token) {
    localStorage.setItem("accessToken", response.access_token);
    if (intendedDestination === "/login" || intendedDestination === "/") {
      router.replace({ name: "home" });
    } else {
      router.replace(intendedDestination);
    }
    return true;
  }

  router.replace({
    name: "login",
    query: { redirect: intendedDestination },
  });
  return false;
}
